import {useRef, useState} from 'react'

import {DispatchTimelinePage} from '../dispatch-timeline/dispatch-timeline-page'
import {DispatchBoardProvider} from './dispatch-board-context'
import {dispatchDataLayer} from './dispatch-data-layer'
import type {BoardWindow} from './dispatch-search'

type DispatchWorkspaceProps = {
    customerId?: string | null
    onCustomerIdChange?: (customerId: string | null) => void
    yardId?: string | null
    onYardChange?: (yardId: string | null) => void
    boardWindow?: BoardWindow
    onBoardWindowChange?: (boardWindow: BoardWindow) => void
}

export function DispatchWorkspace({
    customerId = null,
    onCustomerIdChange,
    yardId = null,
    onYardChange,
    boardWindow,
    onBoardWindowChange,
}: DispatchWorkspaceProps = {}) {
    const [ownWindow, setOwnWindow] = useState<BoardWindow>({viewRange: 'week', anchorOffset: 0})
    const {viewRange, anchorOffset} = boardWindow ?? ownWindow
    // Tracks the latest window so consecutive changes in one render compose.
    const latestWindow = useRef<BoardWindow>({viewRange, anchorOffset})
    latestWindow.current = {viewRange, anchorOffset}
    const changeWindow = (next: BoardWindow) => {
        latestWindow.current = next
        setOwnWindow(next)
        onBoardWindowChange?.(next)
    }

    return (
        <DispatchBoardProvider
            dataLayer={dispatchDataLayer}
            viewRange={viewRange}
            anchorOffset={anchorOffset}
        >
            <DispatchTimelinePage
                viewRange={viewRange}
                onViewRangeChange={(next) => changeWindow({viewRange: next, anchorOffset: 0})}
                anchorOffset={anchorOffset}
                onAnchorOffsetChange={(next) =>
                    changeWindow({...latestWindow.current, anchorOffset: next})
                }
                customerId={customerId}
                onCustomerIdChange={onCustomerIdChange}
                yardId={yardId}
                onYardChange={onYardChange}
            />
        </DispatchBoardProvider>
    )
}
